"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ReferenceResolver = require("reference-resolvers/ReferenceResolver");

var _ResolverLoading = _interopRequireDefault(require("reference-resolvers/schema/ResolverLoading"));

var _ResolverError = _interopRequireDefault(require("reference-resolvers/schema/ResolverError"));

var _atom = require("atom");

var _immutable = require("immutable");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var createCache = function createCache(atom) {
  (0, _atom.swap)(atom, function (cache) {
    return cache != null ? cache : (0, _immutable.Map)({
      loading: false,
      loaded: false
    });
  });
  return {
    setLoading: function setLoading() {
      (0, _atom.reset)(atom, (0, _immutable.Map)({
        loading: Date.now(),
        loaded: false
      }));
    },
    setError: function setError(error) {
      (0, _atom.reset)(atom, (0, _immutable.Map)({
        loading: false,
        loaded: false,
        error: error
      }));
    },
    setLoadedData: function setLoadedData(data) {
      (0, _atom.reset)(atom, (0, _immutable.Map)({
        loading: false,
        loaded: true,
        data: data
      }));
    },
    listen: function listen(onUpdate) {
      (0, _atom.watch)(atom, onUpdate);
      onUpdate((0, _atom.deref)(atom));
      return function () {
        (0, _atom.unwatch)(atom, onUpdate);
      };
    }
  };
};

var createSimpleCachedReferenceResolver = function createSimpleCachedReferenceResolver(_ref) {
  var cacheKey = _ref.cacheKey,
      createFetchData = _ref.createFetchData,
      fetchData = _ref.fetchData,
      httpClient = _ref.httpClient,
      _ref$selectReferences = _ref.selectReferences,
      selectReferences = _ref$selectReferences === void 0 ? _identity.default : _ref$selectReferences;
  (0, _invariant.default)(cacheKey && typeof cacheKey === 'string', 'expected `cacheKey` to be a non-empty string');

  if (httpClient) {
    (0, _invariant.default)(!!createFetchData, 'createFetchData factory function not provided for supplied httpClient for simple resolver');
    fetchData = createFetchData({
      httpClient: httpClient
    });
  }

  return function (getCacheAtom) {
    var cache = createCache(getCacheAtom(cacheKey));

    var resolveReferences = function resolveReferences(next, resolve) {
      return cache.listen(function (state) {
        if (state.get('loading')) {
          next((0, _ResolverLoading.default)({
            startDate: state.get('loading')
          }));
        } else if (state.get('error')) {
          next((0, _ResolverError.default)({
            reason: state.get('error')
          }));
        } else if (state.get('loaded')) {
          var refs = selectReferences(state.get('data'));
          resolve(refs);
        } else {
          cache.setLoading();
          fetchData().then(cache.setLoadedData).catch(cache.setError);
        }
      });
    };

    return (0, _ReferenceResolver.makeReferenceResolver)({
      byId: function byId(id, next) {
        return resolveReferences(next, function (refs) {
          return next(refs.get(id));
        });
      },
      all: function all(next) {
        return resolveReferences(next, function (refs) {
          return next(refs.valueSeq());
        });
      }
    }, "SimpleCachedReferenceResolver_" + cacheKey);
  };
};

var _default = createSimpleCachedReferenceResolver;
exports.default = _default;
module.exports = exports.default;